import React from 'react';
import moment from 'moment';
import { Row, Col } from 'reactstrap';
import { red500, green500, blue500 } from 'material-ui/styles/colors';
import { ListItem, Avatar, RaisedButton, Divider } from 'material-ui';
import FontAwesome from 'react-fontawesome';
import Alert from 'material-ui/svg-icons/alert/error';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import Bus from 'material-ui/svg-icons/maps/directions-bus';
import User from 'material-ui/svg-icons/action/account-circle';

import * as penalizacionesAction from '../action'; // Asegúrate de importar las acciones correctas

const PenalizacionRow = ({ penalizacion, dispatch }) => {
  if (!penalizacion || !penalizacion.get) return null;
  const usuario = penalizacion.get('_usuario') || penalizacion.get('_usuarioAbonado');
  const reserva = penalizacion.get('_reserva');
  const canceladaBy = penalizacion.get('_canceladaBy');
  const minutos = penalizacion.get('minutosPreviosComienzoViaje');
  let text;
  if (minutos <= 60 && minutos >= -60) text = Math.abs(minutos) + ' minutos';
  else text = Math.round(Math.abs(minutos / 60) * 10) / 10 + ' horas';

  if (!reserva) return null;
  const solucionar = (penalizacionId) => dispatch(penalizacionesAction.solucionar(penalizacionId, false, true));
  const pagar = (penalizacionId) => dispatch(penalizacionesAction.solucionar(penalizacionId, true, true));

  return (
    <div>
      <ListItem
        leftAvatar={penalizacion.get('solucionado') ? <Avatar icon={<CheckCircle />} backgroundColor={green500} /> : <Avatar icon={<Alert />} backgroundColor={red500} />}
        disabled
        className="noMargin"
        primaryText={
          <Row className="listIcon p-lr-10">
            <Col md="2">
              <Row>
                <Col md="1">
                  <Bus />
                </Col>
                <Col md="10" className="mt-5">
                  {moment(reserva.get('horarioViaje')).format('DD/MM HH:mm')} - {reserva.get('nombreTrayecto')}
                </Col>
              </Row>
              <Row style={{ paddingTop: 10 }}>
                <Col md="1">
                  <FontAwesome name="usd" className="iconInfo pr-10" />
                </Col>
                <Col md="10" className="mt-5">
                  <b>{penalizacion.get('costo')}</b>
                </Col>
              </Row>
            </Col>
            <Col md="2">
              <Row>
                <Col md="1">
                  <User color={blue500} />
                </Col>
                <Col md="10" className="mt-5">
                  {usuario && usuario.get('nombre')} {usuario && usuario.get('apellido')}
                  <br />
                  {penalizacion.get('documentoUsuario')}
                </Col>
              </Row>
            </Col>
            <Col md="3">
              Reserva fechas:
              <br />
              Realizada: {moment(reserva.get('fechaRealizada')).format('DD/MM/YYYY')}
              <br />
              Cancelada: {moment(reserva.get('fechaCancelada')).format('DD/MM/YYYY')}
              <br />
              <b>
                Cancelo {text} {minutos < 0 ? 'antes' : 'despues'}
              </b>
            </Col>
            <Col md="2">
              Creado por chofer: {reserva.get('creadaPorChofer') ? <b>Sí</b> : 'No'}
              <br />
              Cuenta corriente: {reserva.get('cuentaCorriente') ? <b>Sí</b> : 'No'}
              <br />
              Cancelada por el usuario: {usuario && canceladaBy == usuario.get('id') ? <b>Sí</b> : 'No'}
            </Col>
            <Col md="3">
              <RaisedButton className="fullWidthComponent noPadding" disabled={penalizacion.get('solucionado')} label="Solucionar" onTouchTap={() => solucionar(penalizacion.get('id'))} />
              <RaisedButton className="fullWidthComponent noPadding" disabled={penalizacion.get('pago')} label="Pagar" onTouchTap={() => pagar(penalizacion.get('id'))} />
            </Col>
          </Row>
        }
      />
      <Divider />
    </div>
  );
};

export default PenalizacionRow;



// WEBPACK FOOTER //
// src/modules/penalizaciones/components/penalizacionRow.js